
import { mapGetters } from 'vuex'

import SectorTag from '@/components/Company/Analysis/StockThemeChart/SectorTag'
import TwoRow from '@/components/Common/Layout/Table/TwoRow'
import ThreeRow from '@/components/Common/Layout/Table/ThreeRow'
import NormalType from '@/components/Common/Layout/Table/NormalType'
import SectorChart from '@/components/Company/Analysis/StockThemeChart/SectorChart'
import SectorDetail from '@/components/Company/Analysis/StockThemeChart/SectorDetail'
export default {
    components: {
        SectorTag,
        TwoRow,
        ThreeRow,
        NormalType,
        SectorChart,
        SectorDetail,
    },
    data() {
        return {
            closeChartBox: false,
        }
    },
    computed: {
        ...mapGetters('search', ['GETTER_THEME', 'GETTER_PRICELIST']),
    },
}
